module.exports = __webpack_public_path__ + "img/4.46ac34f1.svg";